import React from 'react';
import EyeShow from "./EyeShow";
import EyeHide from "./EyeHide";
import ChevronDown from "./ChevronDown";
import Icon from '@ant-design/icons';
const EyeShowIcon = (props) => <Icon component={EyeShow} {...props}/>;
const EyeHideIcon = (props) => <Icon component={EyeHide} {...props}/>;
const ChevronDownIcon = (props) => <Icon component={ChevronDown} {...props}/>;
export { EyeShowIcon, EyeHideIcon, ChevronDownIcon, };
